import type { CSSProperties } from "react";
import { CtaLink } from "@/features/marketing/CtaLink";
import { TromboneClip } from "@/features/marketing/art/TromboneClip";

/**
 * La page manquante du dossier : la feuille du fond se pose, le trombone se
 * trace, puis la feuille détachée se balance au bout et s'immobilise
 * (styles/motion.css). Une fois, sans mouvement : l'état final d'emblée.
 */
function LooseSheet() {
  return (
    <div
      aria-hidden="true"
      data-scene="feuille-detachee"
      data-shown="true"
      className="relative mx-auto mt-14 h-[230px] w-[196px] sm:h-[270px] sm:w-[230px] lg:mt-0"
      style={{ "--draw-duration": "700ms" } as CSSProperties}
    >
      <div className="enc-sheet-in absolute inset-0 -rotate-3 rounded-md bg-logo-sheet-back" />
      <div
        className="enc-swing absolute inset-0 rotate-[5deg] rounded-md bg-logo-sheet-front px-5 pt-11 shadow-card"
        style={{ "--enter-delay": "650ms" } as CSSProperties}
      >
        <span className="block h-2 w-3/4 rounded-full bg-primary/20" />
        <span className="mt-4 block h-2 w-full rounded-full bg-primary/10" />
        <span className="mt-2.5 block h-2 w-5/6 rounded-full bg-primary/10" />
        <span className="mt-2.5 block h-2 w-2/3 rounded-full bg-primary/10" />
        <span className="absolute right-4 bottom-3 font-mono text-caption text-primary/70">p. 404</span>
      </div>
      <div className="absolute -top-9 left-[70%] -translate-x-1/2 text-primary">
        <TromboneClip height={72} draw delay={200} />
      </div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <section className="mx-auto max-w-[1200px] px-4 py-20 sm:px-6 lg:grid lg:grid-cols-2 lg:items-center lg:gap-16 lg:px-8 lg:py-28">
      <div>
        <p className="font-mono text-sm font-semibold text-action">Erreur 404</p>
        <h1 className="mt-4 max-w-[16ch] font-display text-4xl leading-tight font-semibold text-primary sm:text-5xl">Cette page est introuvable.</h1>
        <p className="mt-5 max-w-lg text-lg leading-relaxed text-muted-foreground">Le lien est peut-être incomplet ou la page a changé d’adresse. Retrouvez le site ou accédez à votre espace de relance.</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <CtaLink to="/">Revenir à l’accueil</CtaLink>
          <CtaLink to="/app" variant="secondary">Accéder à mon espace</CtaLink>
        </div>
      </div>
      <LooseSheet />
    </section>
  );
}
